import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import endpoint from "../../../auth/endpoint";
import { Button, Form, Modal } from "react-bootstrap";
import Loader from "react-loader-advanced";
import { SuccessAlert, ErrorAlert } from "../../../toasst/toast";
import Header from "../../shared/Header";
import style from "./style.css";
import { Link, useHistory } from "react-router-dom";

export const AssignedJusticesFullCourt = () => {
  const history = useHistory();
  const [data, SetJustices] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [deleteModal, SetDeleteModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [assignedJusticesList, SetAssignedJusticesList] = useState([]);
  const [courtRoom, setcourtRoom] = useState([]);
  const [panelList, setPanelList] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedRow, setSelectedRow] = useState({
    id: "",
    name: "",
  });
  const [cases, setCases] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [inputValueCaseId, setInputValueCaseId] = useState(null);
  const openDeleteModal = async () => {
    SetDeleteModal(true);
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const getJusticeList = async () => {
    setLoading(true);
    try {
      const res = await endpoint.get("/justice/list");
      console.log("justice", res.data.data);
      SetJustices(res.data.data);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    const filteredSuggestions = cases.filter((caseItem) =>
      caseItem.suite_no.toLowerCase().includes(value.toLowerCase())
    );
    setSuggestions(filteredSuggestions);

    // setDeactivateDetails({ ...deactivateDetails, SuitNo: value });
  };

  const handleSuggestionClick = (suggestion) => {
    setInputValue(suggestion.suite_no);
    setInputValueCaseId(suggestion.case_id)

    //endpoint to fetch assignments for the selected case
    getAssignedJusticeListFullCourt(myDate, location, suggestion.case_id)

    setSuggestions([]);
  };

  useEffect(() => {
    getJusticeList();
    getPanelList();
  }, []);

    const getPanelList = async () => {
      setLoading(true);
      try {
        const res = await endpoint.get("/panel/get-all-panel");
        setPanelList(res.data.data);
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
    };

  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  const handleCheckboxChange = (row) => {
    const selectedIndex = selectedRows.findIndex(
      (selectedRow) => selectedRow.id === row.id
    );
    let newSelectedRows = [];

    if (selectedIndex === -1) {
      newSelectedRows = [...selectedRows, row];
    } else if (selectedIndex === 0) {
      newSelectedRows = [...selectedRows.slice(1)];
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelectedRows = [...selectedRows.slice(0, -1)];
    } else if (selectedIndex > 0) {
      newSelectedRows = [
        ...selectedRows.slice(0, selectedIndex),
        ...selectedRows.slice(selectedIndex + 1),
      ];
    }

    setSelectedRows(newSelectedRows);
    // setSelectedRows({justice_id:newSelectedRows.id, newSelectedRows});
  };

  const filteredData = data.filter(
    (item) =>
      item.name.includes(filterText.toLowerCase()) ||
      item.rank.includes(filterText.toLowerCase())
  );

  const columns = [
    // {
    //   name: "S/N",
    //   cell: (row, index) => index + 1,
    //   width: "60px",
    // },
    {
      name: "...",
      selector: (row) => [row.name],
      style: { textAlign: "left" },
      sortable: true,
      width: "70px",
      cell: (row) => (
        <div className="fs-12 fw-bold">
          <input
            className="checkbox text-primary"
            type="checkbox"
            checked={selectedRows.some(
              (selectedRow) => selectedRow.id === row.id
            )}
            onChange={() => handleCheckboxChange(row)}
          />
        </div>
      ),
    },
    {
      name: "Name",
      selector: (row) => [row.name],
      style: { textAlign: "left" },
      sortable: true,
      width: "400px",
      cell: (row) => (
        <div className="fs-12 fw-bold">
          {/* <input
            className="checkbox text-primary"
            type="checkbox"
            checked={selectedRows.some(
              (selectedRow) => selectedRow.id === row.id
            )}
            onChange={() => handleCheckboxChange(row)}
          /> */}
          {row.name}
        </div>
      ),
    },
    {
      name: "Email",
      selector: (row) => [row.email],
      style: { textAlign: "right" },
      sortable: true,
      width: "300px",
      cell: (row) => <div className="fs-12 fw-bold">{row.email}</div>,
    },
    {
      name: "Rank",
      selector: (row) => [row.rank],
      style: { textAlign: "right" },
      sortable: true,
      width: "220px",
      cell: (row) => <div className="fs-12 fw-bold">{row.rank}</div>,
    },
  ];

  const tableDatas = {
    columns,
    data,
    filter: true,
    filterText: filterText,
    filterUpdate: handleFilter,
  };

  const [myDate, setMyDate] = useState("");
  const [location, setLocation] = useState("");
  const [panel, setPanel] = useState("");
  const [addMoreJusticeModal, setAddMoreJusticeModal] = useState(false)
  const [newJustice, setNewJustice] = useState(null)

  const openAddMoreJusticeModal = async () => {
    setAddMoreJusticeModal(true);
  };

  const handleSubmitSelectedUsers = async (e) => {
    e.preventDefault();
    console.log("selected date", myDate);
    if (!myDate) {
      return ErrorAlert("Please select a date")
    }
    if (selectedRows.length == 0) {
      return ErrorAlert("Please select Justices")
    }
    const formattedDate = selectedDate
      ? selectedDate.toISOString().substring(0, 10)
      : null;

    const selectedRowsWithDate = selectedRows.map((row) => ({
      justice_id: row.id,
      sitting_date: myDate.toString(),
      location: location,
      case_id: inputValueCaseId,
      panel: panel,
    }));

    // console.log(selectedRowsWithDate);
    // return

    try {
      setLoading(true)
      await endpoint
        .post("/justice/assign-by-case", selectedRowsWithDate)
        .then((res) => {
          console.log("res", res);
          SuccessAlert(res.data.message);
          setSelectedRows([])
          setTimeout(() => {
            getAssignedJusticeListFullCourt(myDate, location, inputValueCaseId);
          }, 500);
          setLoading(false)
        })
        .catch((err) => {
          ErrorAlert(err.response.data.message);
          console.log(err);
          setLoading(false)
        });
    } catch (error) {
      console.log(error);
    }
  };

  const dateSuffix = (day) => {
    if (day == 1 || day == 21 || day == 31) {
      return day + "" + "st";
    } else if (day == 2 || day == 22) {
      return day + "" + "nd";
    } else if (day == 3 || day == 23) {
      return day + "" + "rd";
    } else {
      return day + "" + "th";
    }
  };

  const formattedDate =
    myDate &&
    (
      new Date(myDate).toLocaleDateString("en-us", { weekday: "long" }) +
      ", " +
      dateSuffix(
        new Date(myDate).toLocaleDateString("en-us", { day: "numeric" })
      ) +
      " day of " +
      new Date(myDate).toLocaleDateString("en-us", { month: "long" }) +
      ", " +
      new Date(myDate).toLocaleDateString("en-us", {
        year: "numeric",
      })
    ).toUpperCase();

  const getAssignedJusticeListFullCourt = async (date, location, inputValueCaseId) => {
    // console.log("date", inputValueCaseId);
    if (!location && !date && !inputValueCaseId) {
      return
      ErrorAlert("Date or location is missing");
    }
    try {
      const res = await endpoint.get(`/justice/qualified-list-assign-by-case`, {
        params: {
          date,
          location,
          case_id: inputValueCaseId,
        },
      });
      console.log("assigned justices List", res.data.data);
      SetAssignedJusticesList(res.data.data);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const handleRemoveassignedJustice = async (date) => {
    console.log("date", myDate);
    console.log("justices ID", selectedRow.id);

    try {
      const res = await endpoint.delete(
        `/justice/delete-assign-by-case/${selectedRow.id}`
      );
      console.log("assigned justices List", res.data.data);
      SuccessAlert(res.data.message);
      SetDeleteModal(false);
      getAssignedJusticeListFullCourt(myDate, location, inputValueCaseId);
    } catch (err) {
      ErrorAlert(err.response.data.message);
      SetDeleteModal(false);
      console.log(err);
    }
    setLoading(false);
  };

  const handleAddMoreJustice = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      await endpoint
        .post("/justice/add-more-justice-assignment-by-case", {justice_id: newJustice, sitting_date: myDate, location: location, case_id: inputValueCaseId, panel: panel})
        .then((res) => {
          SuccessAlert(res.data.message);
          setAddMoreJusticeModal(false)
          setSelectedRows([])
          setTimeout(() => {
            getAssignedJusticeListFullCourt(myDate, location, inputValueCaseId);
          }, 500);
          setLoading(false)
        })
        .catch((err) => {
          ErrorAlert(err.response.data.message);
          console.log(err);
          setLoading(false)
        });
    } catch (error) {
      console.log(error);
    }

  }

  const getAllCaseForADate = async (date) => {
    console.log("case date", date);
    await endpoint
      .get(`/case-diary/cause-list2`, { params: { date } })
      .then((res) => {
        setcourtRoom(new Set(res.data.data.map(({ location }) => location)))
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getAllCaseForADateAndRegistry = async (date, location) => {
    setCases([])
    await endpoint
      .get(`/case-diary/cause-list2`, { params: { date, location } })
      .then((res) => {
        console.log("cases for reg", res.data.data)
        setCases(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <>

      <>
        <div className="container my-4">
          {/* Page Heading */}
          <div className="text-center mb-4">
            <h2 className="fw-bold">Assign Justices (Full Court)</h2>
            <p className="text-danger">**
              Please select registry, date and case, click on the checkboxes beside the names to select justices,
              and then click <strong>Assign button</strong> on the bottom of the page.**
            </p>
          </div>

          {/* Date Picker */}
          <div className="row justify-content-center mb-3">
            <div className="col-md-3">
              <label className="form-label fw-semibold">Select Date</label>
              <input
                className="form-control"
                type="date"
                value={myDate}
                onChange={(e) => {
                  setMyDate(e.target.value);
                  getAllCaseForADate(e.target.value);
                }}
                required
              />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-semibold">Select Registry</label>
              <select type="text" className="form-control"
                onChange={(e) => {
                  setLocation(e.target.value);
                  getAllCaseForADateAndRegistry(myDate, e.target.value);
                  // getAssignedJusticeList(e.target.value, location);
                }}
                required>
                <option value="">--select--</option>
                {courtRoom &&
                  [...courtRoom].map((room, idx) => (
                    <option key={idx} value={room}>
                      {room}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-semibold">Select Panel</label>
              <select type="text" className="form-control"
                onChange={(e) => {
                  setPanel(e.target.value);
                }}
                required>
                <option value="">--select--</option>
                {panelList &&
                  panelList.map((panel, idx) => (
                    <option key={idx} value={panel.title}>
                      {panel.title}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-md-3">
              <Form.Group>
                <label htmlFor="exampleInputName1">
                  Appeal No.
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={inputValue}
                  onChange={handleInputChange}
                  required
                />

                {suggestions.length > 0 && (
                  <ul
                    style={{
                      listStyleType: "none",
                      margin: 0,
                      padding: "5px 0",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      backgroundColor: "#fff",
                      maxHeight: "200px",
                      overflowY: "auto",
                      position: "absolute",
                      zIndex: 1000,
                      width: "100%",
                    }}
                  >
                    {suggestions.map((suggestion) => (
                      <li
                        key={suggestion.id}
                        onClick={() => handleSuggestionClick(suggestion)}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f1f1f1")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor = "transparent")
                        }
                      >
                        {suggestion.suite_no}
                      </li>
                    ))}
                  </ul>)}
              </Form.Group>
            </div>
          </div>

          {isLoading ? (
            <div className="d-flex align-items-center justify-content-center vh-100">
              <img
                src={"/loading.gif"}
                alt={""}
                className="img-fluid"
                style={{ maxWidth: "50px" }}
              />
            </div>
          ) : (<>
            {/* Justice Selection Table */}
            <div className="card shadow-sm mb-4">
              <div className="card-body">
                <h5 className="card-title">Current Justices of The Supreme Court of Nigeria</h5>
                <DataTable
                  fixedHeader
                  columns={columns}
                  data={filteredData}
                  defaultSortField="id"
                  defaultSortAsc={true}
                  striped
                  highlightOnHover
                  pagination
                  paginationServer
                  paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
                />
                <div className="text-end mt-3">
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={(e) => handleSubmitSelectedUsers(e)}
                  >
                    Assign
                  </Button>
                </div>
              </div>
            </div>
          </>)}

          {/* Assigned Justices Section */}
          {assignedJusticesList.length > 0 ? (
            <div className="card shadow-sm">
              <div className="card-body">
                <h4 className="card-title text-center mb-3">
                  <span className="text-primary">{formattedDate}</span> <br></br>
                  SITTING ARRANGEMENT <br></br>
                  {location}: {panel} <br></br>
                  {inputValue}
                </h4>
                <div className="table-responsive">
                  <div>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => {
                        openAddMoreJusticeModal();

                      }}
                    >
                      Add more
                    </Button>
                  </div>
                  <table className="table table-striped">
                    <thead className="table-light">
                      <tr>
                        <th>S/N</th>
                        <th>Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignedJusticesList.map((user, index) => (
                        <tr key={user.id}>
                          <td>{index + 1}</td>
                          <td>{user?.Justice?.name}</td>
                          <td>
                            <Button
                              className="btn btn-danger btn-sm"
                              onClick={() => {
                                setSelectedRow({
                                  id: user?.id,
                                  name: user.Justice.name,
                                });
                                openDeleteModal();
                              }}
                            >
                              Remove
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center mt-4 text-muted">
              No Justices assigned for this date
            </div>
          )}

          {/* Delete Modal */}
          <Modal show={deleteModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Removal</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <p>
                Are you sure you want to remove <br />
                <strong>{selectedRow.name}</strong> <br /> from{" "}
                <strong>{formattedDate}</strong>?
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => SetDeleteModal(false)}>
                Cancel
              </Button>
              <Button
                variant="danger"
                onClick={(e) => {
                  handleRemoveassignedJustice();
                }}
              >
                Remove
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Add New Justice Modal */}
          <Modal show={addMoreJusticeModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Add New Justice</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <div className="col-12">
                <label className="form-label fw-semibold">Select Justice</label>
                <select type="text" className="form-control"
                  onChange={(e) => {
                    setNewJustice(e.target.value);
                    // getAssignedJusticeList(e.target.value, location);
                  }}
                  required>
                  <option value="">--select--</option>
                  {data.map((justice) => (
                    <option key={justice.id} value={justice.id}>
                      {justice.name}
                    </option>
                  ))}
                </select>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setAddMoreJusticeModal(false)}>
                Cancel
              </Button>
              <Button
                variant="success"
                onClick={(e) => {
                  handleAddMoreJustice(e);
                }}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>

    </>
  );
};
